'use client';
import { useEffect, useState } from 'react';
import ShipTestTruckLayout from './ship-test-truck-layout';
import { db } from '@/lib/db';
import { useDispatch } from 'react-redux';
import { setShipTestData } from '@/redux/slices/ship-test/shipTestSlice';
import { showSuccessToast, showErrorToast } from "@/components/toast/toast";

interface OfflineShipTestProps {
  projectId: string;
  isOffline?: boolean;
}

export default function OfflineShipTest({ projectId, isOffline }: OfflineShipTestProps) {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const loadShipTestData = async () => {
      if (projectId) {
        try {
          setIsLoading(true);
          const project = await db.getFullProject(projectId);

          if (project?.shipTestData) {
            dispatch(setShipTestData(project.shipTestData));
          }
        } catch (error) {
          console.error('Error loading ship test data:', error);
          showErrorToast('Failed to load ship test configuration');
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    loadShipTestData();
  }, [projectId, dispatch]);

  const handleOfflineSubmit = async (values: any) => {
    try {
      const project = await db.getFullProject(projectId);
      if (project) {
        await db.projects.update(projectId, {
          ...project,
          shipTestData: {
            ...values,
            updatedAt: new Date().toISOString()
          }
        });
        showSuccessToast("Ship test data saved offline");
      }
    } catch (error) {
      console.error('Error saving ship test data:', error);
      showErrorToast("Failed to save ship test data");
    }
  };

  if (isLoading) {
    return <div>Loading ship test configuration...</div>;
  }

  return (
    <ShipTestTruckLayout
      projectId={projectId}
      isOffline={isOffline}
      onOfflineSubmit={handleOfflineSubmit}
    />
  );
}
